import classnames from 'classnames';
import MapDirection from 'components/MapDirection';
import { FORMAT_DATE_FOR_DISPLAY, FORMAT_TIME } from 'constants/days';
import deviceSizes from 'constants/deviceSizes';
import useWindowSize from 'hooks/useWindowSize';
import moment from 'moment';
import React from 'react';
import { IAppointment } from 'types/appointments';
import { GeneralFunction } from 'types/common';
import { ITransactionType } from 'types/services';
import { appointmentTypeOptionsArray } from 'types/transaction';
import { formatAddress } from 'utils';

import { useCommonActionButtonsForAppointments } from '../NotaryAppointments/helpers';
import PaymentText from './PaymentText';
import { AddSignatoryContainerStyled, AvatarContainerStyled, DataCardStyled } from './styled';

const AppointmentCard: React.FC<{
  appointment: IAppointment;
  refetch?: GeneralFunction;
  onCardClick?: GeneralFunction;
  // showNotaryModal: GeneralFunction;
  transactionTypesData?: ITransactionType[];
}> = ({ appointment, refetch, onCardClick, transactionTypesData }) => {
  const { isMobile } = useWindowSize(deviceSizes.numbers.md);
  const avatarClassName = classnames({
    // 'gx-pb-3': isMobileView,
  });
  // const [markCompleteAlertVisible, setMarkCompleteAlertVisible] = useState(false);

  const { Modal, AppointmentActionButtons } = useCommonActionButtonsForAppointments({
    appointment,
    refetch,
    transactionTypesData,
  });

  // const [updateAssignment] = useMutation(UPDATE_APPOINTMENT_ASSIGNMENT);
  // const [updateAppointment] = useMutation(UPDATE_APPOINTMENT);

  // const mutationComplete = (error?: any) => {
  //   if (!error) {
  //     notification.success({
  //       message: 'Request changed successfully!',
  //       duration: 2,
  //     });
  //     refetch?.();
  //   } else {
  //     console.error('Error', error);
  //     notification.error({
  //       message: error.message || 'Request error! Please try again',
  //       duration: 2,
  //     });
  //   }
  // };

  // const mutateAssignment = async (assignmentStatus: AssignmentStatus, assignment?: IAssignment) => {
  //   if (!assignment) return;
  //   try {
  //     await updateAssignment({
  //       variables: {
  //         filter: {
  //           id: assignment.id,
  //         },
  //         updatedDoc: {
  //           status: assignmentStatus,
  //         },
  //       },
  //     });
  //     mutationComplete();
  //   } catch (err) {
  //     mutationComplete(err);
  //   }
  // };

  // const acceptAppointment = (assignment?: IAssignment) => {
  //   mutateAssignment(AssignmentStatus.APPROVED, assignment);
  // };

  // const rejectAppointment = (assignment?: IAssignment) => {
  //   mutateAssignment(AssignmentStatus.REJECTED, assignment);
  // };

  // const markAppointmentAsCompleted = async () => {
  //   if (!appointment) return;
  //   try {
  //     await updateAppointment({
  //       variables: {
  //         filter: {
  //           id: appointment.id,
  //         },
  //         updatedDoc: {
  //           status: AppointmentStatus.COMPLETED,
  //         },
  //       },
  //     });
  //     defaultNotification({ success: 'Mark appointment completed successfully!' });
  //   } catch (err) {
  //     defaultNotification({ failure: 'Somethign went wrong! Please try again' });
  //   } finally {
  //     setMarkCompleteAlertVisible(false);
  //   }
  // };

  // const completeAppointmentClick = () => {
  //   setMarkCompleteAlertVisible(true);
  // };

  // const cancelCompleteAppointment = () => {
  //   setMarkCompleteAlertVisible(false);
  // };

  const appointmentOwner = appointment.transaction?.createdBy;
  const creatorFullName = `${appointmentOwner?.firstName} ${appointmentOwner?.lastName}`;
  const appointmentTime = moment(appointment.date);
  const allTransactionSignatories = appointment.transaction?.signatories;
  let signatoryCount = 0;
  const signatoryText = appointment.signatoryIds.reduce((acc: string, sigId) => {
    const matchedSignatory = allTransactionSignatories?.find((sig) => sig.id === sigId);
    if (matchedSignatory) {
      signatoryCount += 1;
    } else {
      return acc;
    }
    if (matchedSignatory && signatoryCount < 3) {
      const sigName = `${matchedSignatory.firstName} ${matchedSignatory?.lastName}`;
      return acc ? `${acc}, ${sigName}` : `${sigName}`;
    }
    return `${acc} and ${signatoryCount - 2} more`;
  }, '' as string);

  return (
    <>
      {Modal}
      <DataCardStyled
        key={appointment.id}
        mobileWidth='100%'
        mobileHeight='auto'
        height='300px'
        responsive
        mobileThreshold={deviceSizes.numbers.md}
        $isMobileView={isMobile}
        onClick={() => {
          onCardClick?.(appointment);
        }}
        avatar={
          <AvatarContainerStyled className={avatarClassName}>
            {/* <Avatar
            style={{ width: 80, height: 80 }}
            src={appointmentOwner?.avatar?.thumbnailPipeFrom || getDefaultAvatarUrl(creatorFullName)}
          /> */}
            <MapDirection
              style={{ width: !isMobile ? '150px' : '100%', height: !isMobile ? '100%' : '240px' }}
              location={appointment.address}
            />
          </AvatarContainerStyled>
        }
        main={
          <div>
            <span
              style={{
                display: 'inline-block',
                borderRight: '1px solid black',
                paddingRight: 10,
                marginRight: 10,
                lineHeight: 0.85,
              }}>
              {appointmentTime.format(FORMAT_DATE_FOR_DISPLAY)}
            </span>
            <span>
              {appointmentTime.format(FORMAT_TIME)} -&nbsp;
              {appointmentTime.add(appointment.duration || 0, 's').format(FORMAT_TIME)}
            </span>
          </div>
        }
        sub={
          <div>
            <div className='gx-my-1 line-clamp-1'>Company: {appointmentOwner?.company?.name}</div>
            <div className='gx-my-1 line-clamp-1'>Client: {creatorFullName}</div>
            <div className='gx-my-1 line-clamp-1'>Transaction Ref: {appointment.transaction?.reference}</div>
          </div>
        }
        extra={[
          <div>Type: {appointmentTypeOptionsArray.find((app) => app.value === appointment.type)?.label}</div>,
          <div>Address: {formatAddress(appointment.address)}</div>,
          <div>Signatories: {signatoryText || 'None'}</div>,
          <div>
            <PaymentText appointment={appointment} transactionTypesData={transactionTypesData} />
          </div>,
        ]}
        rightSide={
          <AddSignatoryContainerStyled align='middle' justify={isMobile ? 'center' : 'end'}>
            <AppointmentActionButtons />
          </AddSignatoryContainerStyled>
        }
      />
    </>
  );
};

export default React.memo(AppointmentCard);
